import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import MultiFileUpload from './MultiFileUpload';

const MultiFileUploadField: React.FC<BaseFieldProps> = props => {
	return (
		<BaseField {...props}>
			<MultiFileUpload />
		</BaseField>
	);
};

export default MultiFileUploadField;
